/* eslint-disable max-len */
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-mtma-rules-access',
    templateUrl: './mtma-rules-access.component.html',
    animations: [],
})
export class MtmaRulesAccessComponent {


    constructor(
        private store: Store<AppState>,
        private formBuilder: FormBuilder,
        private translate: TranslateService,
    ) { }
}

